import { Grid } from '@material-ui/core'
import { useModificationAndSpecificationsQuery } from '@src/queries/ConfiguratorModificationsAndSpecifications.generated'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import React, { useEffect } from 'react'
import {
  InsertModificationArgs,
  useProductFromQueryParam,
  SequenceType,
} from '../../ProductsConfiguration'
import useFormikHelper from '../../useFormikHelper'
import BaseModifications from './BaseModifications'
import { ModificationTypes } from '../../enum'
import { groupBy } from 'lodash'
import { BiTubeProduct } from '../../../BiTube/enum'
import ModificationsAccordion from './ModificationsAccordion'
import FiveAndInternalModifications from './FiveAndInternalModifications'

interface ModificationsProps {
  insertModificationIntoSequence: ({
    value,
    resetMod,
    isAntiSense,
  }: InsertModificationArgs) => Promise<string>
  showCommonAccordion?: boolean
  sequenceType?: SequenceType
  showBasesForAcceptor?: boolean
}

const Modifications: React.FC<ModificationsProps> = ({
  insertModificationIntoSequence,
  showCommonAccordion = true,
  sequenceType,
  showBasesForAcceptor = false,
}) => {
  const formik = useFormikHelper()
  const { isCustomerServiceRep, isCustomProductCSR, userIsLoggedIn } =
    useCurrentUser()
  const product = useProductFromQueryParam()

  const { LightCycler } = BiTubeProduct
  const { data, loading: modificationAndSpecificationsLoading } =
    useModificationAndSpecificationsQuery({
      variables: {
        product: {
          productType: product,
          isCSR: isCustomerServiceRep,
          isCSRSupervisor: isCustomProductCSR,
          isRegUser: userIsLoggedIn,
        },
      },
      ssr: false,
      fetchPolicy: 'cache-first',
    })

  const modifications =
    data?.getModificationAndSpecifications?.modifications || []

  const { Base, InternalMod } = ModificationTypes
  const groupedModifications = groupBy(modifications, 'modificationType')
  const [degenerateBasesData] = groupedModifications[Base] || []
  const { Primary, Secondary } = SequenceType
  const [antiSenseFiveModData] =
    groupedModifications?.['antiSenseFiveMod'] || []
  const [internalModData] = groupedModifications?.[InternalMod] || []

  useEffect(() => {
    formik.setFieldValue('loading', modificationAndSpecificationsLoading, false)
  }, [modificationAndSpecificationsLoading])

  return (
    <Grid container>
      <Grid item xs={12}>
        {showCommonAccordion && (
          <ModificationsAccordion
            insertModificationIntoSequence={insertModificationIntoSequence}
            groupedModifications={groupedModifications}
            sequenceType={sequenceType}
          />
        )}
        {product === LightCycler && sequenceType === Primary && (
          <BaseModifications
            disabled={false}
            degenerateBasesData={degenerateBasesData}
            insertModificationIntoSequence={insertModificationIntoSequence}
            isLNABaseEnable={!!formik.selectedOligoValues.isLNABaseEnable}
          />
        )}
        {product === LightCycler &&
          sequenceType === Secondary &&
          !showBasesForAcceptor && (
            <FiveAndInternalModifications
              disabled={false}
              fiveModData={antiSenseFiveModData}
              internalModData={internalModData}
              insertModificationIntoSequence={insertModificationIntoSequence}
              isAntiSense
            />
          )}
        {showBasesForAcceptor && (
          <BaseModifications
            disabled={false}
            degenerateBasesData={degenerateBasesData}
            insertModificationIntoSequence={insertModificationIntoSequence}
            isLNABaseEnable={!!formik.selectedOligoValues.isLNABaseEnable}
            isAntiSense
          />
        )}
      </Grid>
    </Grid>
  )
}

export default Modifications
